<template>
  <notifi-input-fields :sign-message-params="props.signMessageParams" />
</template>

<script lang="ts" setup>
import {
  NotifiFrontendClient,
  SupportedCardConfigType,
} from '@notifi-network/notifi-frontend-client';
import { NotifiInputFields } from '../../components';

const props = defineProps<{
  signMessageParams: Parameters<NotifiFrontendClient['logIn']>[0];
  cardDataEventTypes: SupportedCardConfigType['eventTypes'];
}>();
</script>
